// @flow
import React, { Fragment } from "react";
import Carousel from '../components/Carousel';
import Footer from '../components/Footer';
import SectionGallery from "./home/SectionGallery";
import SectionTestimonial from "./home/SectionTestimonial";
import SectionContactUs from "./home/SectionContactUs";
import Heading from "../components/Heading";

export class Home extends React.Component {
  render() {
    return (
      <Fragment>
        <Heading heading={true} />
        <Carousel />
        <SectionGallery />
        <SectionTestimonial />
        <SectionContactUs />
        <Footer />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js